(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gingerkite-sticky-buy')) {
    customElements.define('gingerkite-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.buttonContainer = this.querySelector('.accelerated-checkout-block');
        if (!this.buttonContainer) return;

        this.resizeObserver = new ResizeObserver(() => {
          if (!this.hasAttribute('data-sticky')) {
            this.style.setProperty('--gingerkite-buy-height', this.buttonContainer.offsetHeight + 'px');
          }
          document.body.style.setProperty('--gingerkite-sticky-space', this.buttonContainer.offsetHeight + 'px');
        });
        this.resizeObserver.observe(this.buttonContainer);

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-sticky', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        }, { threshold: 0 });
        this.visibilityObserver.observe(this);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
